"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _AuthorisationWrapper = require("../../AuthorisationWrapper"),
    _WithPublicLink = _interopRequireDefault(require("../../WithPublicLink")),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _api = require("../api"),
    _CreditsProvider = _interopRequireDefault(require("../components/CreditsProvider"));

function Credits(a) {
  var b = a.children;
  return _react["default"].createElement(_AuthorisationWrapper.AuthorisationConsumer, null, function (a) {
    var c = a.selectedOrganisation.organisationId;
    return _react["default"].createElement(_RequestProvider["default"], {
      requests: {
        getOrganisation: (0, _api.getOrganisationQuery)(c),
        getUserTeams: (0, _api.getUserTeamsQuery)(c)
      }
    }, function (a) {
      var d = a.getOrganisation,
          e = a.getUserTeams;
      return _react["default"].createElement(_CreditsProvider["default"], {
        organisationId: c,
        getOrganisation: d,
        getUserTeams: e
      }, b);
    });
  });
}

var _default = (0, _WithPublicLink["default"])(Credits);

exports["default"] = _default;